'use strict';

module.exports = {
    /**
     * @param {jQuery} input JQuery input element
     * @returns {jQuery} JQuery invalid feedback element
     */
    getInvalidFeedbackElement: function (input) {
        let $invalidFeedback;
        let floatingLabelDiv = input.parents('.div-floating-label');

        if (floatingLabelDiv.length) {
            $invalidFeedback = input.parents('.form-group').find('.invalid-feedback');
        } else {
            $invalidFeedback = input.next('.invalid-feedback');
        }
        return $invalidFeedback;
    }
}
